import React from 'react';
import styled from 'styled-components';
import colors from '../../styles/colors';
import { textSizesPx, spaceSizesPx } from '@nauto/core';

interface TabsMenuProps {
  className?: string;
  tabs: string[];
  setTabContent?: (selectedTab: string) => JSX.Element;
  switchTabHandler?: (event: any) => void;
  defaultSelectedTab?: string;
}

interface TabsMenuState {
  selectedTab: string;
}

class TabsMenu extends React.Component<TabsMenuProps, TabsMenuState> {
  state = {
    selectedTab: this.props.defaultSelectedTab || this.props.tabs[0],
  };

  switchTab = selectedTab => {
    const { switchTabHandler } = this.props;
    this.setState({ selectedTab });
    if (switchTabHandler) {
      switchTabHandler(selectedTab);
    }
  };

  handleSwitchTab = tab => () => this.switchTab(tab);

  render() {
    const { className, setTabContent, tabs } = this.props;
    const { selectedTab } = this.state;

    return (
      <div className={className}>
        <div className="tabs-menu">
          <div className="tabs-menu-wrap">
            {tabs.map((tab, key) => (
              <div
                key={key}
                className={`tab ${tab === selectedTab ? 'active' : ''}`}
                onClick={this.handleSwitchTab(tab)}
              >
                {tab}
              </div>
            ))}
          </div>
        </div>
        {setTabContent && (
          <div className="tabs-menu-content">{setTabContent(selectedTab)}</div>
        )}
      </div>
    );
  }
}

const StyledTabsMenu = styled(TabsMenu)`
  .tabs-menu {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    .tabs-menu-wrap {
      display: flex;
      box-shadow: 0px 1px 10px 1px ${colors.grey300};
      .tab {
        color: ${colors.grey900};
        text-decoration: none;
        font-size: ${textSizesPx.md};
        padding: 10px 30px;
        border: 1px solid ${colors.grey300};
        :not(:first-child) {
          border-left: 0;
        }
        :hover {
          color: black;
        }
        :first-letter {
          text-transform: uppercase;
        }
      }
    }
    .tabs-menu-wrap .active {
      color: ${colors.blue500};
      font-family: Circular-Bold;
      cursor: default;
      :hover {
        color: ${colors.blue500};
      }
    }
  }
  .tabs-menu-content {
    margin: ${spaceSizesPx.md} ${spaceSizesPx.xl} 0;
    height: 100%;
  }
`;

export default StyledTabsMenu as any;
